import {
	performPostRequest,
	performPutRequest,
} from '@atlassian/jira-fetch/src/utils/requests.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { BaseUrl, ProjectId, IssueId } from '@atlassian/jira-shared-types/src/general.tsx';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (baseUrl: BaseUrl, projectId: ProjectId, parentId: IssueId, childId: IssueId) =>
	fg('stop_using_simplified_endpoint_in_cip')
		? performPutRequest(`/rest/api/3/issue/${childId}`, {
				body: JSON.stringify({
					fields: {
						parent: { id: parentId },
					},
				}),
			})
		: performPostRequest(
				`${baseUrl}/rest/internal/simplified/1.0/projects/${projectId}/issues/${parentId}/children`,
				{
					body: JSON.stringify({
						issueIds: [childId],
					}),
				},
			);
